export function dispose(callback) {
    return (source) => source.lift(new DisposeOperator(callback));
}
class DisposeOperator {
    constructor(callback) {
        this.callback = callback;
    }
    call(subscriber, source) {
        const subscription = source.subscribe(subscriber);
        subscription.add(this.callback);
        return subscription;
    }
}
//# sourceMappingURL=dispose.js.map